import { type AriaRole, type ReactElement, type ReactNode } from 'react'
import flattenChildren from 'react-keyed-flatten-children'

import { RadioGroupProvider, RadioItemProvider } from '@lib/radio-context'

interface RadioGroupProps {
  value: string
  onChange: (value: string) => void
  children: ReactNode
  className?: string
  role?: AriaRole
}

const RadioGroup = ({
  value,
  onChange,
  children,
  className,
  role = 'radiogroup',
}: RadioGroupProps) => {
  const items = flattenChildren(children) as ReactElement[]

  return (
    <RadioGroupProvider value={value} items={items} onChange={onChange}>
      <div role={role} className={className}>
        {items.map((item, index) => (
          <RadioItemProvider key={item.key} index={index}>
            {item}
          </RadioItemProvider>
        ))}
      </div>
    </RadioGroupProvider>
  )
}

export default RadioGroup
